<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="openOcr"
               class="comment-dialog"
               :modal="false">
      <div slot="title"
           class="dialog-header">
        <img class="collect-icon"
             src="@/assets/images/bookIcons/OCR1.png"
             alt="">
        <div class="collect-title">OCR</div>
        <div class="line-area"></div>
      </div>
      <div class="text"
           v-loading="loading">{{text}}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RetrieveDialogOcr',
  props: {
    openOcr: {
      type: Boolean,
      required: true
    },
    bookId: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      text: '',
      loading: true
    }
  },
  created () {
    this.getText()
  },
  methods: {
    getText () {
      let params = new URLSearchParams()
      params.append('bookId', this.bookId)
      params.append('page', this.currentPage)
      this.loading = true
      this.$http.post('retrieve/page/getOCR', params).then((res) => {
        let textList = res.data.message
        textList = JSON.parse(textList)[0]
        textList.forEach((item) => {
          item['right'] = Math.max(...item.text_region.map((position) => position[0]))
          item['left'] = Math.min(...item.text_region.map((position) => position[0]))
          item['bottom'] = Math.max(...item.text_region.map((position) => position[1]))
          item['top'] = Math.min(...item.text_region.map((position) => position[1]))
        })
        textList = textList.sort((a, b) => {
          return b.right + b.left - a.right - a.left
        })
        while (textList.length > 0) {
          let rightMostText = textList.shift()
          let columnTextList = [rightMostText]
          for (let i = 0; i < textList.length; i++) {
            if (textList[i].right > rightMostText.left) {
              columnTextList.push(textList[i])
              textList.splice(i, 1)
              i = i - 1
            }
          }
          columnTextList = columnTextList.sort((a, b) => {
            return a.bottom + a.top - b.bottom - b.top
          })
          this.text = this.text + columnTextList.map((text) => text.text).join('') + '\n'
        }
        this.loading = false
      })
    }
  },
  watch: {
    openOcr () {
      this.$emit('closeOcr', false)
    }
  }
}
</script>

<style scoped>
* {
  color: #634c37;
  font-size: 16px;
}

::-webkit-scrollbar {
  background-color: #f5eee8;
  width: 4px;
}

::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
}

.comment-dialog >>> .el-dialog {
  width: 260px !important;
  height: 571px !important;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #f7f6f5;
  margin-right: 160px;
  text-align: left;
}

.collect-icon {
  width: 16.19px;
  height: 15.79px;
}

.comment-dialog >>> .el-dialog__header {
  padding: 15px 0 0 16px;
}

.comment-dialog >>> .el-dialog__body {
  padding: 19px 11px 0px 15px;
}

.collect-title {
  font-size: 18px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #9e5c1d;
  display: inline;
  margin: 0 0 13px 10px;
  bottom: 13px;
}

.line-area {
  width: 115px;
  margin-top: 12px;
  border-bottom: 1px solid #9e5c1d;
}

.img {
  width: 14.14px;
}

.title {
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #634c37;
  line-height: 0px;
  display: inline;
  margin-left: 2px;
}

.text {
  line-height: 36px;
  height: 460px;
  overflow-y: auto;
  white-space: pre-wrap;
}

.comment-dialog >>> .el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
}

.comment-dialog >>> .el-dialog__headerbtn i {
    height: 20px;
    width: 25px;
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDialogOcr.vue